import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";
import {
  Phone,
  Mail,
  Globe,
  MessageCircle,
  Info,
  Clock,
  HeartHandshake,
} from "lucide-react";

/**
 * ☎️ Página “Soporte y Contacto” — Versión extendida
 */
const AboutContact = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      {/* 🧭 Contenedor principal */}
      <div className="flex flex-col gap-7.5">
        {/* 📘 Card principal */}
        <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
          {/* 🔹 Encabezado */}
          <div className="border-b border-stroke px-4 py-6 dark:border-strokedark sm:px-6 xl:px-9">
            <h3 className="text-lg font-semibold text-black dark:text-white flex items-center gap-2">
              <Info className="h-5 w-5 text-primary" />
              Soporte y Contacto
            </h3>
            <p className="mt-2 text-sm text-gray-600 dark:text-gray-400 max-w-3xl leading-relaxed">
              En <strong>Codenova POS</strong> trabajamos para ofrecerte un servicio
              técnico cercano, confiable y eficiente. Nuestro equipo de soporte está
              disponible para ayudarte con cualquier duda, incidencia o asesoría sobre
              el uso del sistema.
            </p>
          </div>

          {/* 🔸 Contenido */}
          <div className="p-4 sm:p-6 xl:p-9 flex flex-col gap-10">
            {/* 📞 Información principal */}
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
              {/* 🧩 Datos de contacto */}
              <div className="flex flex-col gap-3 text-sm leading-relaxed text-gray-600 dark:text-gray-400">
                <p className="flex items-center gap-2">
                  <Mail className="h-4 w-4 text-primary" />
                  <strong>Correo de soporte:</strong>{" "}
                  <a
                    href="mailto:codenovasoportesv@gmail.com"
                    className="text-primary underline"
                  >
                    codenovasoportesv@gmail.com
                  </a>
                </p>

                <p className="flex items-center gap-2">
                  <Phone className="h-4 w-4 text-primary" />
                  <strong>Teléfono / WhatsApp:</strong> +503 7732 0837
                </p>

                <p className="flex items-center gap-2">
                  <Clock className="h-4 w-4 text-primary" />
                  <strong>Horario de atención:</strong>{" "}
                  Lunes a Viernes, de 8:00 AM a 5:00 PM (hora El Salvador)
                </p>
              </div>

              {/* 🎨 Ícono decorativo */}
              <div className="flex items-center justify-center">
                <div className="flex h-20 w-20 items-center justify-center rounded-full bg-primary/10 text-primary shadow-md">
                  <MessageCircle className="h-10 w-10" />
                </div>
              </div>
            </div>

            {/* 💡 Tipos de soporte */}
            <div>
              <h4 className="mb-3 text-base font-semibold text-black dark:text-white">
                Tipos de Soporte que Ofrecemos
              </h4>
              <ul className="list-disc list-inside text-sm leading-relaxed text-gray-600 dark:text-gray-400 space-y-2">
                <li>
                  <strong>Soporte técnico:</strong> resolución de incidencias,
                  errores del sistema o problemas de acceso.
                </li>
                <li>
                  <strong>Capacitación:</strong> acompañamiento en el uso correcto de
                  cada módulo (ventas, compras, inventario, DTE, reportes, etc.).
                </li>
                <li>
                  <strong>Asesoría personalizada:</strong> orientación sobre cómo
                  adaptar Codenova POS a las necesidades específicas de tu negocio.
                </li>
                <li>
                  <strong>Actualizaciones y mantenimiento:</strong> implementación de
                  mejoras, nuevas funciones y parches de seguridad.
                </li>
              </ul>
            </div>

            {/* 🌐 Otros canales */}
            <div>
              <h4 className="mb-3 text-base font-semibold text-black dark:text-white">
                Canales Oficiales de Comunicación
              </h4>
              <ul className="list-disc list-inside text-sm leading-relaxed text-gray-600 dark:text-gray-400 space-y-2">
                <li className="flex items-center gap-2">
                  <MessageCircle className="h-4 w-4 text-primary" />
                  <span>
                    <strong>WhatsApp Empresarial:</strong>{" "}
                    <a
                      href="https://wa.me/50377320837"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary underline"
                    >
                      +503 7732 0837
                    </a>
                  </span>
                </li>
                <li className="flex items-center gap-2">
                  <Globe className="h-4 w-4 text-primary" />
                  <span>
                    <strong>Facebook:</strong>{" "}
                    <a
                      href="https://www.facebook.com/profile.php?id=61579330541453"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary underline"
                    >
                      facebook.com/CodenovaPOS
                    </a>
                  </span>
                </li>
                {/* <li className="flex items-center gap-2">
                  <Globe className="h-4 w-4 text-primary" />
                  <span>
                    <strong>Sitio Web Oficial:</strong>{" "}
                    <a
                      href="https://www.codenovastudios.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary underline"
                    >
                      www.codenovastudios.com
                    </a>
                  </span>
                </li> */}
              </ul>
            </div>

            {/* 🤝 Filosofía de atención */}
            <div className="flex flex-col sm:flex-row gap-5">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
                <HeartHandshake className="h-6 w-6" />
              </div>
              <div>
                <h4 className="mb-2 text-base font-semibold text-black dark:text-white">
                  Filosofía de Atención
                </h4>
                <p className="text-sm leading-relaxed text-gray-600 dark:text-gray-400">
                  En <strong>Codenova POS</strong> creemos que el soporte no termina
                  con la instalación del sistema. Acompañamos a cada cliente durante
                  su crecimiento, ofreciendo asistencia oportuna, respuestas claras y
                  mejoras constantes. Nuestra meta es ser un socio tecnológico de
                  confianza, no solo un proveedor de software.
                </p>
              </div>
            </div>

            {/* 💬 Mensaje final */}
            <div className="mt-6 border-t border-stroke pt-6 dark:border-strokedark">
              <p className="text-sm leading-relaxed text-gray-600 dark:text-gray-400 text-center">
                Agradecemos la confianza de cada empresa que elige{" "}
                <strong>Codenova POS</strong>. Nos esforzamos cada día para ofrecer un
                servicio de excelencia y soluciones que realmente marquen la
                diferencia.{" "}
                <span className="text-primary font-medium">
                  Tu éxito también es el nuestro.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </DefaultLayout>
  );
};

export default AboutContact;
